import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import D from './RespostasRapidas.design';

// Cada linha lê como a mensagem que ela é: tile do tipo, nome e o começo do texto.
export const TIPO_META = {
  texto: { icon: 'eva:message-square-outline', tile: D.typeTexto, label: 'Texto' },
  arquivo: { icon: 'eva:attach-2-outline', tile: D.typeArquivo, label: 'Arquivo' },
  audio: { icon: 'eva:mic-outline', tile: D.typeAudio, label: 'Áudio' },
};

export function metaDoTipo(tipo) {
  return TIPO_META[tipo] || TIPO_META.texto;
}

export function nomeDoArquivo(row) {
  const key = row?.files?.[0]?.key;
  if (!key) return null;
  const base = String(key).split('/').pop();
  return base || null;
}

function resumo(row) {
  if (row.tipo === 'audio') return 'Mensagem de voz';
  if (row.tipo === 'arquivo') return nomeDoArquivo(row) || 'Arquivo anexado';
  const texto = (row?.resposta || '').replace(/\s+/g, ' ').trim();
  if (!texto) return 'Sem texto';
  return texto.length > 90 ? `${texto.slice(0, 90)}…` : texto;
}

function dataCurta(valor) {
  if (!valor) return '—';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function TableRespostasRapidas({ data, onEdit, onDelete }) {
  return (
    <div className={D.tableWrap}>
      <div className={D.tableHeadRow}>
        <div className="w-9 flex-shrink-0" aria-hidden />
        <div className={`flex-1 min-w-[220px] ${D.tableHead}`}>Resposta</div>
        <div className={`w-[110px] flex-shrink-0 hidden md:block ${D.tableHead}`}>Criada em</div>
        <div className={`w-[76px] flex-shrink-0 text-right ${D.tableHead}`}>Ações</div>
      </div>

      {data.map((row) => {
        const meta = metaDoTipo(row.tipo);
        return (
          <div key={row._id} className={D.tableRow}>
            <div className={`${D.tableIcon} ${meta.tile}`} title={meta.label}>
              <Iconify icon={meta.icon} width={17} />
            </div>

            <div className="flex-1 min-w-[220px]">
              <p className={D.tableName}>{row.titulo}</p>
              <p className={D.tableSnippet}>{resumo(row)}</p>
            </div>

            <div className={`w-[110px] flex-shrink-0 hidden md:block ${D.tableDate}`}>{dataCurta(row.data)}</div>

            <div className={`w-[76px] ${D.tableActions}`}>
              <button type="button" onClick={() => onEdit(row)} className={D.iconButton} title="Editar">
                <Iconify icon="eva:edit-2-outline" width={16} />
              </button>
              <button type="button" onClick={() => onDelete(row)} className={D.iconButtonDanger} title="Excluir">
                <Iconify icon="eva:trash-2-outline" width={16} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

TableRespostasRapidas.propTypes = {
  data: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
